<div #errorContainer *ngIf="!hasError; else genericError"></div>

<ng-template #genericError>
  <div class="messageArea">
    <p i18n="@@shared.error.txtSomethingWentWrong">Something went wrong.</p>
    <p i18n="@@shared.error.txtContactAdministrator">Please contact your administrator.</p>
  </div>
</ng-template>
